import * as React from 'react';
import { useQuery } from "graphql-hooks";
import { Button } from 'reactstrap';
import { useOidc } from '@axa-fr/react-oidc';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES } from '../../utilities/constValues';
import { Loading } from '../Shared/Loading';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentHeading } from '../Shared/Content/ContentHeading';
import { ContentBody } from '../Shared/Content/ContentBody';
import { useAPIErrorContext } from '../../contexts/apiErrorContext';
import { clientConfig } from '../../utilities/configService';
import parse from 'html-react-parser';

const CMS_QUERY = `query dataQuery {
  pageHomePage {
    fieldWhySwitchBody
    fieldWhySwitchLinkText
    fieldWhySwitchSectionTitle
  }
}`;

export const WhySwitch = () => {
    const { login } = useOidc();

    const { loading, error, data } = useQuery(CMS_QUERY, {
        variables: {
            limit: 10
        }
    });
    const { trackError } = useAPIErrorContext();

    if (!error && !loading) {
        return (
            <ContentBlock className="homepageWhySwitch">
                <ContentHeading title={data.pageHomePage.fieldWhySwitchSectionTitle} />
                <ContentBody>
                    <div className="body" dangerouslySetInnerHTML={{ __html: data.pageHomePage.fieldWhySwitchBody }} />
                    <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={
                        <Button className="solidNeg primaryButton iconRightArrow text-nowrap" onClick={() => login("/Login")}>{clientConfig?.CONTENT.WHY_SWITCH_BUTTON ? parse(clientConfig.CONTENT.WHY_SWITCH_BUTTON as string) : 'Get Started'}</Button>
                    }></PermissionsGate>
                </ContentBody>
            </ContentBlock>
        );
    }
    else if (!error) {
        return (<Loading showContent={false} includeHero={false} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<> </>);
    }
};
